<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :span='10'>
            <a-form-item :label="'日期'" :labelCol='{span: 6}' :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.dataDt'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :md='4' :sm='6'>
            <a-form-item :label="'批次号'">
              <a-input v-model='queryParam.batchSerial'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='4' :sm='6'>
            <a-form-item :label="'状态'">
              <a-select default-value='' style='width: 120px' v-model='queryParam.status'>
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='0'>
                  待放款
                </a-select-option>
                <a-select-option value='1'>
                  放款成功
                </a-select-option>
                <a-select-option value='2'>
                  放款失败
                </a-select-option>
                <a-select-option value='9'>
                  放款校验失败
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='4' :sm='6'>
            <a-form-item :label="'订单号'">
              <a-input v-model='queryParam.orderNo'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='4' :sm='6'>
            <a-form-item :label="'手机号'">
              <a-input v-model='queryParam.mobileNo'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='4' :sm='6'>
            <a-form-item :label="'银行账号'">
              <a-input v-model='queryParam.bankAccount'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload'
                        style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <span style='float: right;overflow: hidden;' class='table-page-search-submitButtons'>
                <b>总订单数： {{ totalCount }} &nbsp;&nbsp;&nbsp;&nbsp;  总金额： {{ totalAmount }}</b>
            </span>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        bordered
        @change='handleTableChange'>
      </a-table>

    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { listPlan } from '@/webpublicapi/payoutBank'

import moment from 'moment/moment'

const I18N_KEY = 'order.'
export default {
  name: 'listBankPlan',
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      totalCount: 0,
      totalAmount: 0,
      total: 0,
      dataSource: [],
      appList: [],
      // 查询条件
      queryParam: {
        dataDt: [moment(), moment()],
        batchSerial: '',
        status: '',
        orderNo: '',
        mobileNo: '',
        bankAccount: ''
      },

      loading: false,
      // 表头
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '日期',
          align: 'left',
          dataIndex: 'batchDate'
        },
        {
          title: '批次号',
          align: 'left',
          dataIndex: 'batchSerial'
        },
        {
          title: '批次序号',
          align: 'left',
          dataIndex: 'payBatchLine'
        },
        {
          title: '订单号',
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: '姓名',
          align: 'left',
          dataIndex: 'names'
        },
        {
          title: '手机号',
          align: 'left',
          dataIndex: 'custMobileNo'
        },
        {
          title: '银行账号',
          align: 'left',
          dataIndex: 'account'
        },
        {
          title: '银行',
          align: 'left',
          dataIndex: 'bankCode'
        },
        {
          title: '放款金额',
          align: 'left',
          dataIndex: 'amount'
        },
        {
          title: '放款结果',
          align: 'left',
          dataIndex: 'payResultCode'
        },
        {
          title: '结果描述',
          align: 'left',
          dataIndex: 'payResultMsg'
        },
        {
          title: '状态',
          align: 'left',
          dataIndex: 'status',
          customRender: (text) => {
            if (text == '0')
              return '待放款' // 转换状态码
            else if (text == '1')
              return '放款成功'
            else if (text == '2')
              return '放款失败'
            else if (text == '3')
              return '放款中'
            else if (text == '9')
              return '校验失败'
            return ''
          }
        },
        {
          title: '更新时间',
          align: 'left',
          dataIndex: 'updateTime'
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: '300px',
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  mounted() {
    window.addEventListener('route-reactivated', this.onRouteReactivated)
  },
  beforeDestroy() {
    window.removeEventListener('route-reactivated', this.onRouteReactivated)
  },
  created() {
    if (sessionStorage.getItem('listBankPlanParam'))
    {
      let listBankPlanParam = JSON.parse(sessionStorage.getItem('listBankPlanParam'))

      if (listBankPlanParam.batchSerial)
        this.queryParam.batchSerial = listBankPlanParam.batchSerial

      if (listBankPlanParam.date)
        this.queryParam.dataDt = [moment(listBankPlanParam.date, 'YYYY-MM-DD'), moment(listBankPlanParam.date, 'YYYY-MM-DD')]
    }
    this.loadData(1)
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      const params = this.getQueryParams()// 查询条件
      listPlan(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
          this.totalCount = res.data.countMap.total
          this.totalAmount = res.data.countMap.totalAmount
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam

      const data = {
        ...this.queryParam,
        dateStart: (dataDt && dataDt.length) ? this.transformTime(dataDt[0]) : undefined,
        dateEnd: (dataDt && dataDt.length) ? this.transformTime(dataDt[1]) : undefined
      }
      delete data.dataDt

      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      const that = this

      that.queryParam.dataDt = [moment(), moment()]
      that.queryParam.batchSerial = ''
      that.queryParam.status = ''
      that.queryParam.orderNo = ''
      that.queryParam.mobileNo = ''
      that.queryParam.bankAccount = ''

      sessionStorage.removeItem('listBankPlanParamOld')
      sessionStorage.removeItem('listBankPlanParam')
    },
    changeModal(visible) {
      this.visible = visible
    },
    onRouteReactivated() {
      console.log('当前页签被切回')

      if (sessionStorage.getItem('listBankPlanParam'))
      {
        let listBankPlanParam = JSON.parse(sessionStorage.getItem('listBankPlanParam'))

        if (listBankPlanParam.batchSerial)
          this.queryParam.batchSerial = listBankPlanParam.batchSerial

        if (listBankPlanParam.date)
          this.queryParam.dataDt = [moment(listBankPlanParam.date, 'YYYY-MM-DD'), moment(listBankPlanParam.date, 'YYYY-MM-DD')]

        if(!sessionStorage.getItem('listBankPlanParamOld') ||  sessionStorage.getItem('listBankPlanParam') !== sessionStorage.getItem('listBankPlanParamOld')) {
          this.loadData(1)
        }
      }
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
